export const LOAD_CATALOG_REQUEST = 'load_catalog_request'
export const LOAD_CATALOG_RESPONSE = 'load_catalog_response'
export const CATALOG_ERROR = 'catalog_error'
